import { Checkbox, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { formatarValorMonetario } from "../../../../../../../helpers/masks"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { TFaturaFechamento, TFaturaFechamentoData, TFaturaNotificacao } from "../../../../../../../types/api/financeiro/detalhar-fechamentos-conta-corrente";
import DialogListaLancamentos from "./DialogListaLancamentos";
import { useState } from "react";
import { PesquisarTitulosAReceber } from "../../../../MIContasReceber/DialogRegistrarRecebimento/FormRecebimentoTitulos/Step01";
import { IDataListaTitulosPagar } from "../../../../../../../types/api/financeiro/pesquisar-titulos-pagar";
import { IDataLancamentos } from "../../../../../../../types/api/financeiro/lancamentos-conta-corrente";
import useImprimirArquivo from "../../../../../../../lib/useImprimirArquivo";
import SendIcon from '@mui/icons-material/Send';
import DialogInfoNotificacao from "./DialogInfoNotificacao";

export default function TableDetalhesFechamento({
    id,
    detalhesFechamento,
    selected,
    handleChangeSelected,
    isEdit
}: TableDetalhesFechamentoProps) {

    const [openDialogListaLancamentos, setOpenDialogListaLancamentos] = useState<boolean>(false)
    const [openDialogInfoNotificacao, setOpenDialogInfoNotificacao] = useState<TModalOpenNotification>({
        fatura: null,
        notificacoes: null,
        modal: false
    })
    const [modalValues, setModalValues] = useState<TModalValues | null>(null)
    const imprimirArquivo = useImprimirArquivo();

    const handleOpenModal = (values: TModalValues) => {

        if (values.id) {
            imprimirArquivo(`financeiro/conta-corrente-consumo/imprimir-fechamento-fatura/${values.id}`)
            return;
        }

        setModalValues(values)
        setOpenDialogListaLancamentos(true)
    }

    const handleCloseModal = () => {
        setModalValues(null)
        setOpenDialogListaLancamentos(false)
    }
    return (
        <>
            <TableContainer sx={{
                '& ::-webkit-scrollbar': {
                    width: '8px',
                },
                '& ::-webkit-scrollbar-thumb': {
                    backgroundColor: '#bdbdbd',
                    borderRadius: '4px',
                }
            }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow >
                            {!isEdit && <TableCell>
                                <Checkbox
                                    checked={
                                        Object.values(detalhesFechamento).length > 0 &&
                                        selected.length === Object.values(detalhesFechamento).length
                                    }
                                    indeterminate={
                                        selected.length > 0 &&
                                        selected.length < Object.values(detalhesFechamento).length
                                    }
                                    onChange={(e) => {
                                        const checked = (e.target as HTMLInputElement).checked;
                                        if (checked) {
                                            const allIds = Object.values(detalhesFechamento).map(item => item.id);
                                            handleChangeSelected(allIds);
                                        } else {
                                            handleChangeSelected([]);
                                        }
                                    }}
                                    slotProps={{ input: { 'aria-label': 'selecionar todos' } }}
                                />
                            </TableCell>}
                            <TableCell><b>Público</b></TableCell>
                            <TableCell><b>Nome</b></TableCell>
                            <TableCell align="right"><b>Créditos</b></TableCell>
                            <TableCell align="right"><b>Débitos</b></TableCell>
                            <TableCell align="right"><b>Total</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            detalhesFechamento &&
                            Object.entries(detalhesFechamento)
                                .sort(([keyA, valueA], [keyB, valueB]) => {
                                    const numA = parseInt(valueA.codigo_publico);
                                    const numB = parseInt(valueB.codigo_publico);

                                    return numA - numB;
                                })
                                .map(([key, value], index) => {
                                    const total = value.debitos - value.creditos;
                                    const isChecked = selected.some((item) => item === value.id);
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                '&:last-child td, &:last-child th': {
                                                    border: 0,
                                                }
                                            }}
                                        >
                                            {!isEdit &&
                                                <TableCell>
                                                    <Checkbox
                                                        checked={isChecked}
                                                        onChange={(e) => {
                                                            const newSelected = [...selected];
                                                            const checked = (e.target as HTMLInputElement).checked;

                                                            if (checked) {
                                                                newSelected.push(value.id);
                                                            } else {
                                                                const index = newSelected.indexOf(value.id);
                                                                if (index > -1) {
                                                                    newSelected.splice(index, 1);
                                                                }
                                                            }
                                                            handleChangeSelected(newSelected);
                                                        }}
                                                        slotProps={{ input: { 'aria-label': 'selecionar item' } }}
                                                    />
                                                </TableCell>}
                                            <TableCell>{value.tipo_publico}{value.codigo_publico}</TableCell>
                                            <TableCell>{value.nome}</TableCell>
                                            <TableCell align="right">{formatarValorMonetario(value.creditos)}</TableCell>
                                            <TableCell align="right">{formatarValorMonetario(value.debitos)}</TableCell>
                                            <TableCell align="right">
                                                <Typography
                                                    variant="subtitle2"
                                                    color={total < 0 ? '#1B5E20' : '#960000'}
                                                >
                                                    {formatarValorMonetario(Math.abs(total))}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    size="small"
                                                    aria-label="delete"
                                                    onClick={() => {
                                                        handleOpenModal({
                                                            id: value.id,
                                                            titulos_receber: value.titulos_receber,
                                                            titulos_pagar: value.titulos_pagar,
                                                            lancamentos: value.lancamentos,
                                                            publico_nome: value.nome,
                                                            publico_codigo: value.codigo_publico,
                                                            tipo_publico: value.tipo_publico,
                                                        });
                                                    }}
                                                >
                                                    <VisibilityIcon
                                                        fontSize="inherit"
                                                        sx={{ color: 'black' }}
                                                    />
                                                </IconButton>
                                                {
                                                    !isEdit &&
                                                    <IconButton
                                                        size="small"
                                                        aria-label="enviar"
                                                        disabled={isEdit}
                                                        sx={{ color: "black" }}
                                                        onClick={() => setOpenDialogInfoNotificacao({
                                                            fatura: value,
                                                            notificacoes: value.notificacao,
                                                            modal: true
                                                        })}
                                                    >
                                                        <SendIcon
                                                            fontSize="inherit"
                                                        />
                                                    </IconButton>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                        }

                    </TableBody>
                </Table>
            </TableContainer>
            {
                openDialogListaLancamentos && modalValues &&
                <DialogListaLancamentos
                    valores={modalValues}
                    open={openDialogListaLancamentos}
                    onClose={() => handleCloseModal()}
                />
            }
            {
                openDialogInfoNotificacao.modal && openDialogInfoNotificacao.fatura &&
                <DialogInfoNotificacao
                    {...{ id }}
                    open={openDialogInfoNotificacao.modal}
                    fatura={openDialogInfoNotificacao.fatura}
                    notificacoes={openDialogInfoNotificacao.notificacoes}
                    onClose={() => setOpenDialogInfoNotificacao({
                        fatura: null,
                        modal: false,
                        notificacoes: null
                    })}
                />
            }
        </>
    )
}

interface TableDetalhesFechamentoProps {
    id: number
    detalhesFechamento: TFaturaFechamento
    selected: number[]
    handleChangeSelected: (itens: number[]) => void
    isEdit: boolean
}

export type TModalValues = {
    id?: number
    titulos_receber: Array<PesquisarTitulosAReceber>
    titulos_pagar: Array<IDataListaTitulosPagar>
    lancamentos: Array<IDataLancamentos>
    publico_nome: string
    publico_codigo: string
    tipo_publico: string
}

type TModalOpenNotification = {
    fatura: TFaturaFechamentoData | null
    notificacoes: TFaturaNotificacao[] | null
    modal: boolean
}